<script setup lang="ts">
definePageMeta({
  title: 'Engineering Capabilities',
  label: 'Capabilities',
  order: 2,
  middleware: (to) => {
    const { path, matched } = to
    if (/\/capabilities\/?$/.test(path)) {
      return navigateTo(['/capabilities', matched[0]?.children[0]?.path].join('/'), {
        redirectCode: 301,
      })
    }
  },
})
</script>

<template>
  <PageRoot>
    <PageHead
      theme="dark"
      :at-root="false"
    >
      <template #parallax>
        <div class="absolute-inset from-icscyan to-icscyan-800 bg-linear-to-b mix-blend-overlay -z-1" />
        <NuxtImg
          src="303edf7e-dbea-4155-95c8-5911766c60ac"
          alt="A decorative background textured like a mountainous rock-face."
          class="scale-y--100 transition-filter absolute-inset object-cover brightness-120 size-full -z-2 dark:brightness-80"
        />
      </template>
    </PageHead>
    <PageBody>
      <NuxtPage />
    </PageBody>
  </PageRoot>
</template>
